import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=2011107b&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&id=2011107b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011107b",
  null
  
)

export default component.exports